import { render } from "./SubTaskInputComponent.vue?vue&type=template&id=00f5e342"
import script from "./SubTaskInputComponent.vue?vue&type=script&lang=js"
export * from "./SubTaskInputComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__